/**
 * @file   src\store\slices\authSlices.ts
 * @brief  This file is responsible for creating auth slices to call actions and state management.
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */

import { createSlice } from '@reduxjs/toolkit';
import { validateUser,  sendLoginOtp, userLogout } from '../actions/authAction';
import { Iauth } from '../../interfaces/authInterface';
// import { userLogout } from '../actions/userAction';

// Initial state.
const authState: Iauth = {
  userInfo: {},
  userId: null,
  userToken: null,
  errorCode: 0,
  errorMessage: null,
  isSuccess: false,
  isLoading: false,
  isOtpLoading: false,
  isOtpSuccess: false,
  otpErrorCode: 0,
  otpErrorMessage: null,
  isLogoutSuccess: false,
};

// Config user slice.
export const authSlice = createSlice({
  name: 'auth',
  initialState: authState,
  reducers: {
    resetAuthState: () => authState,
  },
  extraReducers(builder) {
    // Start validate user request.
    builder.addCase(validateUser.pending, (state) => {
      state.isSuccess = false;
      state.isLoading = true;
      state.errorCode = 0;
      state.errorMessage = '';
      // state.forgotMailSentSuccess = false;
    });
    // Validate user request success.
    builder.addCase(validateUser.fulfilled, (state, action) => {
      const data = action.payload?.data || {};
      const error = action.payload?.error || 0;
      state.isLoading = error === 0;
      state.isSuccess = true;
      state.userInfo = data;
      state.errorCode = error;
      state.errorMessage =action.payload?.message;
    });
    // Validate user error.
    builder.addCase(validateUser.rejected, (state, action: any) => {
      const error = action.payload?.error || 0;
      state.isSuccess = false;
      state.isLoading = false;
      state.errorCode = error;
      state.errorMessage =action.payload?.message;
    });
    
    // Start send otp request.
    builder.addCase(sendLoginOtp.pending, (state) => {
      state.isOtpSuccess = false;
      state.isOtpLoading = true;
      state.otpErrorCode = 0;
      state.otpErrorMessage = null;
    });
    // Send otp request success.
    builder.addCase(sendLoginOtp.fulfilled, (state, action) => {
      const error = action.payload?.error || 0;
      state.isOtpLoading = false;
      state.isOtpSuccess = true;
      state.otpErrorCode = error;
      state.otpErrorMessage = action.payload?.message;
    });
    // Send otp token error.
    builder.addCase(sendLoginOtp.rejected, (state, action: any) => {
      const error = action.payload?.error || 0;
      state.isOtpSuccess = false;
      state.isOtpLoading = false;
      state.otpErrorCode = error;
      state.otpErrorMessage = action.payload?.message;
    });
     // Start userLogout request.
     builder.addCase(userLogout.pending, (state) => {
      state.isLoading = true;
      state.errorCode = 0;
      state.errorMessage = '';
    });
    // userLogout reqest success.
    builder.addCase(userLogout.fulfilled, (state, action) => {
      const error = action.payload?.error || 0;
      state.isLoading = false;
      state.isLogoutSuccess = true;
      state.errorCode = error;
      state.errorMessage =action.payload?.message;
      state.userInfo = {};
      state.userId = null;
      state.userToken = null;
      state.errorCode = 0;
      state.errorMessage = null;
      state.isSuccess = false;
      state.isLoading = false;
    });
    // userLogout error.
    builder.addCase(userLogout.rejected, (state, action: any) => {
      const error = action.payload?.error || 0;
      state.isLoading = false;
      state.errorCode = error;
      state.errorMessage =action.payload?.message;
    });

  },
});
// Export auth actions.
export const { resetAuthState } = authSlice.actions;
// Export reducer.
export default authSlice.reducer;
